<template>
    <div class="container mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <!-- 页面头部 -->
        <div class="mb-12">
            <h1 class="text-3xl font-bold text-primary mb-2">作家中心</h1>
            <p class="text-gray-600">管理您的创作内容，查看数据并更新个人信息</p>
        </div>

        <!-- 功能导航栏 -->
        <div class="mb-8 bg-white rounded-lg shadow-md p-6">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <!-- 上传入口 -->
                <div class="bg-primary/5 hover:bg-primary/10 rounded-lg p-4 cursor-pointer" @click="goToSlecter">
                    <div class="flex items-center justify-center h-16">
                        <i class="fa fa-upload text-2xl text-primary mr-3"></i>
                        <div>
                            <h3 class="text-lg font-medium">上传内容</h3>
                            <p class="text-sm text-gray-500">上传小说或诗歌</p>
                        </div>
                    </div>
                </div>

                <!-- 内容管理 -->
                <div class="bg-secondary/5 hover:bg-secondary/10 rounded-lg p-4 cursor-pointer" @click="goToNewNovel">
                    <div class="flex items-center justify-center h-16">
                        <i class="fa fa-list-alt text-2xl text-secondary mr-3"></i>
                        <div>
                            <h3 class="text-lg font-medium">新建小说</h3>
                            <p class="text-sm text-gray-500">建立/发布新的小说</p>
                        </div>
                    </div>
                </div>

                <!-- 个人信息 -->
                <div class="bg-accent/5 hover:bg-accent/10 rounded-lg p-4 cursor-pointer" @click="goToProfile">
                    <div class="flex items-center justify-center h-16">
                        <i class="fa fa-user text-2xl text-accent mr-3"></i>
                        <div>
                            <h3 class="text-lg font-medium">个人信息</h3>
                            <p class="text-sm text-gray-500">编辑个人简介</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 快捷操作区（可展开） -->
        <div class="bg-white rounded-lg shadow-md p-6 mb-8">
            <h2 class="text-xl font-medium mb-4">快捷操作</h2>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <!-- 精选作品 -->
                <div class="bg-neutral-50 p-4 rounded-lg">
                    <h3 class="text-sm font-medium text-gray-700 mb-2">精选作品</h3>
                    <p class="text-sm text-gray-500">点击管理您的精选内容</p>
                    <button
                        class="mt-4 bg-primary text-white px-4 py-2 rounded-full hover:bg-primary/90"
                        @click="goToFeatured"
                    >
                        管理精选
                    </button>
                </div>

                <!-- 数据统计（预留） -->
                <div class="bg-neutral-50 p-4 rounded-lg">
                    <h3 class="text-sm font-medium text-gray-700 mb-2">创作数据</h3>
                    <p class="text-sm text-gray-500">待开发：查看阅读量、评论等</p>
                </div>
            </div>
        </div>

        <!-- 近期操作记录（预留） -->
        <div class="bg-white rounded-lg shadow-md p-6">
            <h2 class="text-xl font-medium mb-4">近期操作</h2>
            <div class="space-y-4">
                <div class="flex items-center">
                    <div class="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                        <i class="fa fa-file-text-o text-primary"></i>
                    </div>
                    <div>
                        <p class="text-sm font-medium">暂无操作记录</p>
                        <p class="text-xs text-gray-500">上传内容后显示历史记录</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- 返回首页按钮 -->
        <button id="back-to-home"
                @click="goToHome"
                class="fixed bottom-8 right-8 bg-primary hover:bg-primary/90 text-white w-12 h-12 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 transform hover:scale-110">
            <i class="fa fa-home"></i>
        </button>
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
// 路由跳转函数
const router = useRouter()

const goToHome = () => {
    router.push('/') // 上传页面路由
}
const goToSlecter = () => {
    router.push('/novelselector') // 上传页面路由
}

const goToNewNovel = () => {
    router.push('/novelManage') // 管理页面路由
}

const goToProfile = () => {
    router.push('/personalMessage') // 个人信息页面路由
}

const goToFeatured = () => {
    router.push('/writer/featured') // 精选管理页面路由
}
</script>

<style scoped lang="scss">
@import "tailwindcss";
@layer utilities {
    .content-auto {
        content-visibility: auto;
    }
    .text-shadow {
        text-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }
    .text-shadow-lg {
        text-shadow: 0 4px 8px rgba(0,0,0,0.12), 0 2px 4px rgba(0,0,0,0.08);
    }
    .backdrop-blur-sm {
        backdrop-filter: blur(4px);
    }
    .scrollbar-hide::-webkit-scrollbar {
        display: none;
    }
    .scrollbar-hide {
        -ms-overflow-style: none;
        scrollbar-width: none;
    }
    .transition-transform-opacity {
        transition-property: transform, opacity;
    }
}
#back-to-home{
    width: 50px;
    height: 50px;
    background-color: #42b983;

}
</style>